module.exports = __webpack_public_path__ + "img/user.ebeaba48.png";